<template>
	<div class="export-popi">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>

		<h1>Export PO/PI</h1>

		<p class="description">
			This page will export selected PI in CSV format.
		</p>

		<div class="single-text-wrapper">
			<b-field label="PI Number (Optional)">
				<b-input v-model="searchPI" placeholder="PI Number" @keyup.native.enter="exportPoPi"></b-input>
			</b-field>

			<b-field label="Select Shop (Optional)" v-if="displayShopSelection">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<b-field label="Select Brand (Optional)" v-if="displayBrandSelection">
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>
		</div>

		<div class="datepickerWrapper">
			<b-field label="Starting Date">
				<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="fromDate" icon="calendar-today"
					><button class="button is-danger" @click="fromDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button></b-datepicker
				>
			</b-field>

			<b-field label="Ending Date">
				<b-datepicker
					:date-formatter="dateFormatter"
					placeholder="Click to select..."
					v-model="toDate"
					icon="calendar-today"
					:min-date="minDate"
					:max-date="maxDate"
					><button class="button is-danger" @click="toDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button></b-datepicker
				>
			</b-field>
		</div>

		<div class="button-container">
			<div class="big-button" @click="exportPoPi()">
				Export PI
			</div>
		</div>

		<div v-if="progress > 0">
			<br /><br />
			{{ statusText }}
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div>
	</div>
</template>

<script>
export default {
	name: 'exportPoPi',
	data: function() {
		return {
			limit: 100,
			fromDate: null,
			toDate: null,
			minDate: null,
			maxDate: null,
			searchPI: null,
			isLoading: false,
			purchaseInvoices: [],
			progress: 0,
			shops: [],
			shopsSuggestions: '',
			selectedShop: null,
			brands: [],
			selectedBrand: null,
			brandSuggestions: '',
			displayShopSelection: true,
			displayBrandSelection: true,
			statusText: ''
		}
	},

	watch: {
		fromDate: function(data) {
			if (data !== null) {
				this.minDate = data

				// Removed as client request
				// this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.toDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 1)
			} else {
				this.toDate = null
			}
		},

		selectedShop: function(data) {
			if (data !== null) {
				this.displayBrandSelection = false
			} else {
				this.displayBrandSelection = true
			}
		},

		selectedBrand: function(data) {
			if (data !== null) {
				this.displayShopSelection = false
			} else {
				this.displayShopSelection = true
			}
		}
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	mounted: async function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		await this.getBrands()

		await this.getShops()
	},

	methods: {
		// Export products on user click
		exportPoPi: async function() {
			// Make sure fromDate is not empty
			if (this.fromDate == null && (this.searchPI == null || this.searchPI == '')) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Please enter Starting date'
				})

				return
			}

			this.purchaseInvoices = []
			this.isLoading = true
			this.progress = 0

			const data = {
				limit: 1000,
				skip: 0,
				populate: ['author'],
				sort: {
					updatedAt: 'desc'
				}
			}

			if (this.selectedShop) {
				data.code = this.selectedShop.shop_id
			}

			if (this.searchPI !== null && this.searchPI !== '') {
				data.code = this.searchPI
			}

			if (this.fromDate) {
				data.time = {}
				data.time.updatedAt = {
					$gte: this.$moment(this.fromDate)
						.set({ hour: 0 })
						.format('x')
				}

				if (this.toDate) {
					data.time.updatedAt.$lte = this.$moment(this.toDate)
						.set({ hour: 23 })
						.format('x')
				}
			}

			const result = await this.$api.getPIs({ data })

			if (result && result.data.count > 0) {
				result.data.list.map(item => {
					this.purchaseInvoices.push(item)
				})
			}

			if (result.data.total > 1000) {
				let totalLoop = Math.ceil(result.data.total / 1000)

				if (totalLoop > 1) {
					var i

					for (i = 1; i < totalLoop; i++) {
						const skip = i * 1000

						data.skip = skip

						const result = await this.$api.getPIs({ data })

						if (result && result.data.count > 0) {
							result.data.list.map(item => {
								this.purchaseInvoices.push(item)
							})
						}
					}
				}
			}

			const purchase_invoice = []

			let processCount = 0

			// Make sure result isn't blank
			if (this.purchaseInvoices.length > 0) {
				// Loop every PI for details
				// await Promise.all(
				// this.purchaseInvoices.map(async pi => {
				for (const pi of this.purchaseInvoices) {
					processCount++
					this.progress = (processCount / this.purchaseInvoices.length) * 100

					let continueProcess = true

					const purchase_invoice_detail = {}
					purchase_invoice_detail.pi = pi.code
					purchase_invoice_detail.author = pi.author.name
					purchase_invoice_detail.po = pi.purchase_order
					purchase_invoice_detail.products = []

					const data = {
						purchase_invoice: pi._id,
						populate: ['product'],
						limit: 1000
					}

					// Get PI Item Details
					const piDetailResult = await this.$api.getPiItemDetail({ data })

					// Get PO Item Details
					const poResult = await this.getPoDetail({
						id: pi.purchase_order,
						populate_purchase_order: ['shop']
					})

					// Search selected shop
					if (this.selectedShop) {
						this.statusText = 'Searching PO/PI for selected Shop'

						if (poResult.data.purchase_order.shop._id !== this.selectedShop._id) {
							continueProcess = false
						}
					} else if (this.selectedBrand) {
						this.statusText = 'Searching PO/PI for selected Brand'

						if (poResult.data.purchase_order.brand !== this.selectedBrand._id) {
							continueProcess = false
						}
					} else {
						this.statusText = 'Loading...'
					}

					if (continueProcess) {
						// Loop all the PI Products
						piDetailResult.data.list.map(piItem => {
							const po_products = {}
							// Search for same in PO Items
							const product_match = poResult.data.purchase_order_items.filter(product => {
								return piItem.product._id == product.product
							})

							const brand = this.brands.filter(brand => {
								return brand._id == piItem.product.brand
							})

							//let product_price =
							//	piItem.product.commission > 0 || piItem.product.original_price < 2 ? piItem.product.price : piItem.product.original_price

							let product_price = piItem.product.commission > 0 || piItem.product.original_price < 2 ? piItem.price : piItem.price

							let brandName = brand && brand.length > 0 ? brand[0].name : 'N/A'

							po_products.shop = poResult.data.purchase_order.shop.shop_id
							po_products.bd_code = piItem.product.bd_code
							po_products.brandName = brandName
							po_products.barcode = piItem.product.barcode
							po_products.name = piItem.product.name
							po_products.price = product_price
							po_products.requestedQty = product_match[0].qty
							po_products.receivedQty = piItem.qty
							po_products.balance = piItem.qty - product_match[0].qty
							po_products.remark = piItem.remark
							po_products.createdAt = piItem.createdAt

							purchase_invoice_detail.products.push(po_products)
						})

						purchase_invoice.push(purchase_invoice_detail)
					}
				}

				this.isLoading = false
				if (purchase_invoice.length > 0) {
					this.generateCSV(purchase_invoice)
				} else {
					this.isLoading = false
					this.$swal.fire({
						icon: 'error',
						title: 'Error...',
						text: 'Nothing found!'
					})
				}
			} else {
				this.isLoading = false
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Nothing found!'
				})

				return
			}
		},

		generateCSV: function(purchase_invoice) {
			let export_csv = ''

			// Loop data
			purchase_invoice.map(pi => {
				export_csv +=
					'PI CODE,SHOP,DATE,TIME,ADMIN NAME,BD CODE,BRAND,BARCODE,NAME,REQUESTED QUANTITY,RECEIVED QUANTITY,PRICE,NET AMOUNT,BALANCE,REMARK\r\n'

				let total_request = 0
				let total_received = 0
				let total_net_price = 0

				// Map all the PI products
				pi.products.map(piProducts => {
					const remark = piProducts.remark ? '"' + piProducts.remark + '"' : ''

					const toAdd = [
						pi.pi,
						piProducts.shop,
						this.$moment(piProducts.createdAt).format('DD/MM/YY'),
						this.$moment(piProducts.createdAt).format('hh:mm a'),
						pi.author,
						piProducts.bd_code,
						piProducts.brandName,
						piProducts.barcode,
						'"' + piProducts.name + '"',
						piProducts.requestedQty,
						piProducts.receivedQty,
						piProducts.price,
						piProducts.receivedQty * piProducts.price,
						piProducts.balance,
						remark
					]

					total_request += piProducts.requestedQty
					total_received += piProducts.receivedQty
					total_net_price += piProducts.receivedQty * piProducts.price

					let row = toAdd.join(',')

					export_csv += row + '\r\n'
				})

				export_csv += ',,,,,,,Total,' + total_request + ',' + total_received + ',,' + total_net_price

				export_csv += '\r\n\r\n'
			})

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Purchase_Invoice_' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			link.click()
			link.remove()

			// Reset all the fields
			this.fromDate = null
			this.toDate = null
			this.minDate = null
			this.searchPI = null
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 2000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.brands = apiGetBrands.data.list
			}
		},

		getPoDetail: async function(data) {
			return await this.$api.getPoDetail({ data })
		},

		getPiItems: async function(data) {
			return await this.$api.getPIItems({ data })
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
